const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalmartLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1800 338.656",
    style: {
      enableBackground: "new 0 0 1800 338.656"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "354.11,0 310.84,216.793 262.271,0 177.938,0 129.369,216.793 86.099,0 0,0  70.204,331.15 170.432,331.15 219.442,111.266 268.452,331.15 366.473,331.15 436.235,0  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M541.541,60.932c-53.426,0-90.956,18.103-104.643,30.907v70.645 c15.895-14.129,49.452-34.881,93.605-34.881c27.375,0,37.53,7.506,37.53,22.96c0,13.246-14.129,18.544-53.426,26.934 c-59.607,12.363-94.047,33.998-94.047,85.658c0,47.686,31.349,75.502,76.827,75.502c38.082,0,60.832-17.665,73.295-41.409v33.903 h82.125V168.666C652.807,94.047,613.952,60.932,541.541,60.932z M530.061,285.231c-19.427,0-30.024-11.921-30.024-28.258 c0-21.194,16.778-29.583,37.972-37.089c11.051-4.144,22.101-8.461,29.583-15.006v36.642 C567.591,269.335,553.021,285.231,530.061,285.231z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 683.538,
    style: {
      fill: "#FFFFFF"
    },
    width: 85.216,
    height: 331.15
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1110.766,61.815c-41.344,0-68.058,24.847-82.038,57.935c-7.493-35.453-32.41-57.935-67.2-57.935 c-39.427,0-65.133,22.991-78.151,55.295V69.321h-83.891V331.15h85.216V185.886c0-35.764,11.921-56.075,37.53-56.075 c20.752,0,27.817,14.129,27.817,36.206V331.15h85.216V185.886c0-35.764,11.921-56.075,37.53-56.075 c20.752,0,27.817,14.129,27.817,36.206V331.15h85.216V154.095C1185.827,98.904,1159.776,61.815,1110.766,61.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1325.351,60.932c-53.426,0-90.956,18.103-104.644,30.907v70.645 c15.895-14.129,49.452-34.881,93.605-34.881c27.375,0,37.53,7.506,37.53,22.96c0,13.246-14.129,18.544-53.426,26.934 c-59.607,12.363-94.047,33.998-94.047,85.658c0,47.686,31.349,75.502,76.827,75.502c38.082,0,60.832-17.665,73.295-41.409v33.903 h82.125V168.666C1436.618,94.047,1397.763,60.932,1325.351,60.932z M1313.871,285.231c-19.427,0-30.024-11.921-30.024-28.258 c0-21.194,16.778-29.583,37.972-37.089c11.051-4.144,22.101-8.461,29.583-15.006v36.642 C1351.402,269.335,1336.831,285.231,1313.871,285.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1549.209,143.295V69.321h-83.45V331.15h85.216V219.884c0-51.218,31.79-64.905,62.256-64.905 c10.155,0,19.869,1.325,24.284,2.649V67.555C1589.566,65.24,1560.44,95.867,1549.209,143.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1800,135.551v-66.23h-54.309V18.544h-85.216v225.182c0,63.139,35.764,92.722,92.722,92.722 c26.492,0,40.621-5.298,46.803-9.272v-65.788c-4.857,3.532-12.804,6.181-22.96,6.181c-18.986,0.442-31.349-7.948-31.349-35.764 v-96.254H1800z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmartLogo);
export default __webpack_public_path__ + "static/media/walmart-logo.b50d0a118fdba68a178be3f01b6609f1.svg";
export { ForwardRef as ReactComponent };